<template>
  <div class="person-card-container">
    <div class="person-card-box" :class="{ full: items.length === 1 }" v-for="person in items" :key="person.id">
      <div class="person-card-avatar" v-if="showInitial && person.initial">
        <div class="person-initial-bg" :style="{ background: person.color }"></div>
        <div class="person-initial-text font-light" :style="{ color: person.color }">{{ person.initial }}</div>
      </div>
      <div class="person-card-title">
        <div>{{ person.fullName }}</div>
        <div class="font-light bold">{{ person.otherDetails }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showInitial: {
      type: Boolean,
      default: false,
      required: true,
    },
    items: {
      type: Array,
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/fonts/stylesheet.css';

.person-card-container {
  font-family:'Gotham Narrow';
  display: flex;
  justify-content: space-between;
  width: 100%;

  .person-card-box {
    border: 1px solid rgba(22, 30, 46, 0.16);
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    padding: 12px;
    margin-top: 5px;
    margin-bottom: 5px;

    &:first-of-type {
      margin-top: 0px
    }

    &:last-of-type {
      margin-bottom: 0px;
    }

    &.full {
      width: 100%;
      margin-top: 0px;
      margin-bottom: 0px;
    }

    .person-card-avatar {
      position: relative;
      margin-right: 15px;
      width: 48px;
      height: 48px;

      .person-initial-bg {
        border-radius: 999999px;
        filter: alpha(opacity=10);
        /* IE */
        -moz-opacity: 0.1;
        /* Mozilla */
        opacity: 0.1;
        /* CSS3 */
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }

      .person-initial-text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-transform: uppercase;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
    }

    .person-card-title {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }

    @media (min-width: 500px) {
      width: 49%;
      margin-top: 0px!important;
      margin-bottom: 0px!important;
    }
  }

  .font-light {
    font-family: "Gotham Narrow Light";

    &.bold {
      font-weight: 600;
    }
  }

  @media (max-width: 500px) {
    flex-direction: column;
  }
}
</style>
